import { render, staticRenderFns } from "./auth-setting.vue?vue&type=template&id=1adf1fa2&scoped=true&"
import script from "./auth-setting.vue?vue&type=script&lang=js&"
export * from "./auth-setting.vue?vue&type=script&lang=js&"
import style0 from "./auth-setting.vue?vue&type=style&index=0&id=1adf1fa2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1adf1fa2",
  null
  
)

export default component.exports